import React from 'react'
import { Divider } from 'semantic-ui-react'
import { StyledFormWrapper } from './style'

interface Props {
  header: string
  children: React.ReactNode
}

const FormWrapper: React.FC<Props> = (props) => {
  const { header, children } = props

  return <StyledFormWrapper>
    <div>
      <div className='header'>{header}</div>
      <Divider className='form-divider' />
    </div>
    {children}
  </StyledFormWrapper>
}
export default FormWrapper